<template>
  <v-chip
    :color="labelColor"
    label
    small
  >
    <span class="caption">
    {{count}}<span v-if="postFix">{{postFix}}</span>
    </span>
  </v-chip>
</template>
<script>
import { getIconColor } from '@/js/store'
export default {
  props: {
    count: Number,
    colorName: String,
    tooltip: String,
    right: Boolean,
    left: Boolean,
    postFix: String
  },
  computed: {
    labelColor () {
      return this.colorName || getIconColor( 'labels')
    },
  }

}
</script>